import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import ListItem from '@mui/material/ListItem';
import { InteractiveIcon } from '../interactiveIcon';
import { LAUNCH_STYLE } from './appSwitcher';
import { onEnterKeyPress } from '../utils/wcagUtils';
export var AppSwitcherItem = function AppSwitcherItem(props) {
  var id = props.id,
    name = props.name,
    icon = props.icon,
    onClick = props.onClick,
    isCurrent = props.isCurrent,
    disabled = props.disabled,
    launchStyle = props.launchStyle;
  var intl = useIntl();
  var openInClassName = 'EmbersAppSwitcher-item-openIn';
  var onButtonClick = function onButtonClick(e) {
    var target = e.target;
    var classList = _toConsumableArray(target.classList);
    // the classlist scan is to test:  did they click on the icon-button which
    //  opens in another tab, for LAUNCH_STYLE.SAME_TAB_WITH_NEW_TAB_OPTIONAL items
    var inNewWindow = launchStyle === LAUNCH_STYLE.NEW_TAB_ONLY || classList.includes(openInClassName) || classList.includes('icon-open-in');
    onClick(inNewWindow);
  };
  var handleKeyDown = function handleKeyDown(e) {
    var _currentTarget$lastCh;
    e.key !== 'Tab' && e.preventDefault();
    var currentTarget = e.currentTarget;
    var currentItemRootElement = currentTarget;
    switch (e.key) {
      case 'Enter':
        onEnterKeyPress(e, onButtonClick);
        break;
      case 'Right': // IE/Edge specific value
      case 'ArrowRight':
        //@ts-ignore
        (_currentTarget$lastCh = currentTarget.lastChild) === null || _currentTarget$lastCh === void 0 || _currentTarget$lastCh.focus();
        break;
      case 'Down': // IE/Edge specific value
      case 'ArrowDown':
        if (!(currentItemRootElement !== null && currentItemRootElement !== void 0 && currentItemRootElement.nextSibling)) {
          var _currentItemRootEleme;
          // if current item is the last item, the next item is the first item of list
          //@ts-ignore
          (_currentItemRootEleme = currentItemRootElement.parentElement) === null || _currentItemRootEleme === void 0 || (_currentItemRootEleme = _currentItemRootEleme.firstChild) === null || _currentItemRootEleme === void 0 || _currentItemRootEleme.focus();
        } else {
          var _currentItemRootEleme2;
          //@ts-ignore
          currentItemRootElement === null || currentItemRootElement === void 0 || (_currentItemRootEleme2 = currentItemRootElement.nextSibling) === null || _currentItemRootEleme2 === void 0 || _currentItemRootEleme2.focus();
        }
        break;
      case 'Left': // IE/Edge specific value
      case 'ArrowLeft':
        //@ts-ignore
        currentTarget === null || currentTarget === void 0 || currentTarget.focus();
        break;
      case 'Up': // IE/Edge specific value
      case 'ArrowUp':
        if (!(currentItemRootElement !== null && currentItemRootElement !== void 0 && currentItemRootElement.previousSibling)) {
          var _currentItemRootEleme3;
          // if current item is the first item, the previous item is the last item of list
          //@ts-ignore
          (_currentItemRootEleme3 = currentItemRootElement.parentElement) === null || _currentItemRootEleme3 === void 0 || (_currentItemRootEleme3 = _currentItemRootEleme3.lastChild) === null || _currentItemRootEleme3 === void 0 || _currentItemRootEleme3.focus();
        } else {
          var _currentItemRootEleme4;
          //@ts-ignore
          currentItemRootElement === null || currentItemRootElement === void 0 || (_currentItemRootEleme4 = currentItemRootElement.previousSibling) === null || _currentItemRootEleme4 === void 0 || _currentItemRootEleme4.focus();
        }
        break;
      default:
        break;
    }
  };
  var content;
  if (launchStyle === LAUNCH_STYLE.NEW_TAB_ONLY) {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "EmbersAppSwitcher-item-icon"
    }, icon), /*#__PURE__*/React.createElement("span", {
      className: "EmbersAppSwitcher-item-name-inline"
    }, name), /*#__PURE__*/React.createElement("div", {
      className: "EmbersAppSwitcher-item-icon-inline ".concat(openInClassName)
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon-open-in"
    })));
  } else {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "EmbersAppSwitcher-item-iconName-group"
    }, /*#__PURE__*/React.createElement("div", {
      className: "EmbersAppSwitcher-item-icon"
    }, icon), /*#__PURE__*/React.createElement("span", {
      className: "EmbersAppSwitcher-item-name"
    }, name)), !isCurrent && launchStyle === LAUNCH_STYLE.SAME_TAB_WITH_NEW_TAB_OPTIONAL && /*#__PURE__*/React.createElement(InteractiveIcon, {
      id: "".concat(id, "-externalLink"),
      className: "EmbersAppSwitcher-item-icon-externalLink ".concat(openInClassName),
      iconName: "icon-open-in",
      iconSize: "small",
      disabled: disabled,
      label: intl.formatMessage({
        id: 'embers.appSwitch.eA.openTo',
        defaultMessage: 'open {app} in new tab'
      }, {
        app: name
      }),
      role: "link"
    }));
  }
  return /*#__PURE__*/React.createElement(ListItem, {
    id: id,
    key: name,
    role: "link",
    "aria-label": launchStyle === LAUNCH_STYLE.NEW_TAB_ONLY ? intl.formatMessage({
      id: 'embers.appSwitch.eA.openTo',
      defaultMessage: 'Open {app} in new tab'
    }, {
      app: name
    }) : name,
    component: "li",
    onClick: !disabled ? onButtonClick : void 0,
    onKeyDown: handleKeyDown,
    className: classnames('EmbersAppSwitcher-item', {
      'EmbersAppSwitcher-item-non-selectable': launchStyle === LAUNCH_STYLE.NEW_TAB_ONLY,
      current: isCurrent,
      disabled: disabled
    }),
    tabIndex: !disabled ? 0 : -1
  }, content);
};